const d = [
    {
        type: 'Feature',
        properties: {
            unique_id: '410329104',
            ext_path: '河南省 洛阳市 伊川县 白沙镇',
            cid: '1',
            pid: '410329',
            name: '白沙镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.567888, 34.376719]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410329110',
            ext_path: '河南省 洛阳市 伊川县 白元镇',
            cid: '2',
            pid: '410329',
            name: '白元镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.431497, 34.360869]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410329108',
            ext_path: '河南省 洛阳市 伊川县 半坡镇',
            cid: '3',
            pid: '410329',
            name: '半坡镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.705158, 34.351783]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410329001',
            ext_path: '河南省 洛阳市 伊川县 城关镇',
            cid: '4',
            pid: '410329',
            name: '城关镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.435972, 34.466082]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410329106',
            ext_path: '河南省 洛阳市 伊川县 高山镇',
            cid: '5',
            pid: '410329',
            name: '高山镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.288295, 34.407053]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410329112',
            ext_path: '河南省 洛阳市 伊川县 葛寨乡',
            cid: '6',
            pid: '410329',
            name: '葛寨乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.378553, 34.279115]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410329105',
            ext_path: '河南省 洛阳市 伊川县 江左镇',
            cid: '7',
            pid: '410329',
            name: '江左镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.699733, 34.43607]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410329109',
            ext_path: '河南省 洛阳市 伊川县 酒后镇',
            cid: '8',
            pid: '410329',
            name: '酒后镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.311487, 34.26076]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410329107',
            ext_path: '河南省 洛阳市 伊川县 吕店镇',
            cid: '9',
            pid: '410329',
            name: '吕店镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.619235, 34.454058]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410329101',
            ext_path: '河南省 洛阳市 伊川县 鸣皋镇',
            cid: '10',
            pid: '410329',
            name: '鸣皋镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.266538, 34.334179]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410329103',
            ext_path: '河南省 洛阳市 伊川县 彭婆镇',
            cid: '11',
            pid: '410329',
            name: '彭婆镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.521173, 34.481821]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410329203',
            ext_path: '河南省 洛阳市 伊川县 平等乡',
            cid: '12',
            pid: '410329',
            name: '平等乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.356943, 34.379795]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410329102',
            ext_path: '河南省 洛阳市 伊川县 水寨镇',
            cid: '13',
            pid: '410329',
            name: '水寨镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.492068, 34.425025]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410329111',
            ext_path: '河南省 洛阳市 伊川县 鸦岭乡',
            cid: '14',
            pid: '410329',
            name: '鸦岭乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.358753, 34.478211]
        }
    }
];

export { d };
